import { gql } from '@apollo/client';

export const GET_ANIMAL_GROUPS_GQL = gql`
  query GetAnimalGroups($barnId: uuid) {
    __typename # Placeholder value
    animal_group(
      where: { barn_id: { _eq: $barnId }, deleted_at: { _is_null: true } }
      order_by: [{ started_at: desc }, { external_id: asc }]
    ) {
      id
      external_id
    }
  }
`;
